import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApp } from "@/lib/store";

export default function CookieBanner() {
  const { t } = useApp();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if the user has already accepted or declined cookies
    const cookieConsent = localStorage.getItem("biten_cookie_consent");
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("biten_cookie_consent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("biten_cookie_consent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 p-4 z-50 pointer-events-none">
      <div className="max-w-4xl mx-auto bg-[#121212] border border-[#27272A] p-5 rounded-2xl shadow-2xl flex flex-col sm:flex-row items-center justify-between gap-4 pointer-events-auto">
        <div className="text-sm text-[#D4D4D8] flex-1">
          <p>
            {t("We use cookies to improve your experience. Some cookies are necessary while others help us understand how you use the service.")} {" "}
            <Link to="/privacy-policy" className="text-[#D4B483] hover:underline">{t("Privacy Policy")}</Link>.
          </p>
        </div>
        <div className="flex gap-3 w-full sm:w-auto">
          <Button
            variant="outline"
            className="flex-1 sm:flex-none border-[#27272A] text-[#EDEDED] hover:bg-[#1A1A1A]"
            onClick={handleDecline}
          >
            {t("Decline")}
          </Button>
          <Button
            className="flex-1 sm:flex-none bg-[#D4B483] text-[#0A0A0A] hover:bg-[#E5CFA5]"
            onClick={handleAccept}
          >
            {t("Accept")}
          </Button>
        </div>
      </div>
    </div>
  );
}
